import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a44e792"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "far fa-file-alt me-2" }),
    /*#__PURE__*/_createTextVNode("ผลการดำเนินการโครงการ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "แสดงข้อมูลผลการดำเนินการโครงการ")
], -1))
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "card card-sub mb-3 pt-2"
}
const _hoisted_5 = { class: "card-body mb-0 pb-0" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-dollar-sign me-2" }),
  /*#__PURE__*/_createTextVNode("งบที่ยังไม่ได้เบิกจ่าย:")
], -1))
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-percent me-2" }),
  /*#__PURE__*/_createTextVNode("ร้อยละของผลงาน:")
], -1))
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "d-flex justify-content-between" }
const _hoisted_14 = { class: "fw-bold" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-hashtag me-2" }, null, -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn p-0",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }),
  /*#__PURE__*/_createTextVNode("จัดการข้อมูล ")
], -1))
const _hoisted_18 = { class: "dropdown-menu" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-edit me-2" }, null, -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-image me-2" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban me-2" }, null, -1))
const _hoisted_28 = { class: "card card-sub mt-2 mb-3" }
const _hoisted_29 = { class: "card-body pb-0" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-sm-6" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-dollar-sign me-2" }, null, -1))
const _hoisted_34 = { class: "text-muted" }
const _hoisted_35 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-percent me-2" }),
  /*#__PURE__*/_createTextVNode("ร้อยละของผลงาน:")
], -1))
const _hoisted_37 = { class: "text-muted" }
const _hoisted_38 = {
  key: 1,
  class: "col-sm-6"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, " ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, " ", -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = { class: "col-sm-6" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar me-2" }),
  /*#__PURE__*/_createTextVNode("วันที่ดำเนินการ:")
], -1))
const _hoisted_44 = { class: "text-muted" }
const _hoisted_45 = { class: "col-sm-6" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }),
  /*#__PURE__*/_createTextVNode("เอกสารการแนบ:")
], -1))
const _hoisted_47 = { class: "text-muted" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-list me-2" }),
  /*#__PURE__*/_createTextVNode("รายละเอียด:")
], -1))
const _hoisted_50 = { class: "text-muted" }
const _hoisted_51 = {
  key: 1,
  class: "d-flex justify-content-between"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-comment-dollar me-2" }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-undo me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectProgressFormComponent = _resolveComponent("ProjectProgressFormComponent")!
  const _component_ProjectReturnFormComponent = _resolveComponent("ProjectReturnFormComponent")!
  const _component_ProjectProgressAttachmentModalComponent = _resolveComponent("ProjectProgressAttachmentModalComponent")!
  const _component_ProjectProgressAttachmentFormComponent = _resolveComponent("ProjectProgressAttachmentFormComponent")!
  const _component_ProjectProgressImageModalComponent = _resolveComponent("ProjectProgressImageModalComponent")!
  const _component_ProjectProgressAttachmentOffcanvasComponent = _resolveComponent("ProjectProgressAttachmentOffcanvasComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isProcured || _ctx.isProgress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.isCompleted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("p", _hoisted_9, _toDisplayString(Number(_ctx.procure?.realBudget - _ctx.progresses.reduce((total, m) => total + m.spent, 0)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.progresses.reduce((total, m) => total + m.percent, 0).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + "%", 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.progresses, (progress, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: progress.id,
                class: "mb-3"
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString((progress.spentType.id === 1) ? `รายละเอียดการเบิกจ่าย งวดที่ ${index + 1}` : `รายละเอียดการคืนงบประมาณ`) + ": ", 1)
                  ]),
                  (_ctx.canEdit && !_ctx.isCanceled && !_ctx.isFinished)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("ul", _hoisted_18, [
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.editClick(progress.id, progress.spentType.id))
                            }, [
                              _hoisted_20,
                              _createTextVNode("แก้ไขผลการดำเนินการ ")
                            ], 8, _hoisted_19)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.attachmentClick(progress.id))
                            }, [
                              _hoisted_22,
                              _createTextVNode("จัดการเอกสารแนบ ")
                            ], 8, _hoisted_21)
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.imageClick(progress.id))
                            }, [
                              _hoisted_24,
                              _createTextVNode("จัดการรูปประกอบ ")
                            ], 8, _hoisted_23)
                          ]),
                          _hoisted_25,
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item",
                              onClick: ($event: any) => (_ctx.deleteClick(progress.id))
                            }, [
                              _hoisted_27,
                              _createTextVNode("ลบผลการดำเนินการ ")
                            ], 8, _hoisted_26)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("span", _hoisted_32, [
                          _hoisted_33,
                          _createTextVNode(" " + _toDisplayString((progress.spentType.id === 1) ? 'งบประมาณที่เบิกจ่าย' : 'งบประมาณที่ส่งคืน') + ": ", 1)
                        ]),
                        _createElementVNode("p", _hoisted_34, _toDisplayString(Number(progress?.spent).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + " บาท", 1)
                      ]),
                      (progress.spentType.id === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("p", _hoisted_37, _toDisplayString(Number(progress?.percent).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + "%", 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_41)),
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createElementVNode("p", _hoisted_44, _toDisplayString(progress?.spentDate ? _ctx.thaiDate(progress?.spentDate) : ''), 1)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createElementVNode("p", _hoisted_47, [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.showAttachment(progress.id)), ["stop","prevent"])
                          }, " ดูเอกสารสารแนบ ", 8, _hoisted_48)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_49,
                      _withDirectives(_createElementVNode("p", _hoisted_50, null, 512), [
                        [_directive_dompurify_html, progress?.remark ? progress?.remark.replace(/\n/g, '<br />') : '-']
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128)),
            (_ctx.canEdit && !_ctx.isCanceled && !_ctx.isSpent && !_ctx.isFinished)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.progressClick && _ctx.progressClick(...args)))
                  }, [
                    _hoisted_52,
                    _createTextVNode("รายงานผลการเบิกจ่ายงบ ")
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-secondary",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.returnClick && _ctx.returnClick(...args)))
                  }, [
                    _hoisted_53,
                    _createTextVNode("รายงานการส่งคืนงบ ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ProjectProgressFormComponent, {
      ref: "progressForm",
      "project-id": _ctx.projectId,
      "progress-id": _ctx.selectedProgressId,
      onRefresh: _ctx.refresh
    }, null, 8, ["project-id", "progress-id", "onRefresh"]),
    _createVNode(_component_ProjectReturnFormComponent, {
      ref: "returnForm",
      "project-id": _ctx.projectId,
      "progress-id": _ctx.selectedProgressId,
      onRefresh: _ctx.refresh
    }, null, 8, ["project-id", "progress-id", "onRefresh"]),
    _createVNode(_component_ProjectProgressAttachmentModalComponent, {
      ref: "attachmentModal",
      "project-id": _ctx.projectId,
      "progress-id": _ctx.selectedProgressId,
      onUpload: _ctx.uploadClick
    }, null, 8, ["project-id", "progress-id", "onUpload"]),
    _createVNode(_component_ProjectProgressAttachmentFormComponent, {
      ref: "attachmentForm",
      "project-id": _ctx.projectId,
      "progress-id": _ctx.selectedProgressId,
      onHidden: _ctx.formHidden
    }, null, 8, ["project-id", "progress-id", "onHidden"]),
    _createVNode(_component_ProjectProgressImageModalComponent, {
      ref: "imageModal",
      "project-id": _ctx.projectId,
      "progress-id": _ctx.selectedProgressId
    }, null, 8, ["project-id", "progress-id"]),
    _createVNode(_component_ProjectProgressAttachmentOffcanvasComponent, {
      ref: "attachmentOffcanvas",
      "progress-id": _ctx.selectedProgressId
    }, null, 8, ["progress-id"])
  ], 64))
}